export const USER_CONSTANTS = {
  LOGIN: "LOGIN",
  PROFILE_DATA: "PROFILE_DATA",
  DEFAULT_PIC_URL: "930ac0fc-20a3-4825-8cd5-eb71c134f3e0.png"
};
